import { render, staticRenderFns } from "./ExternalDataWidget.vue?vue&type=template&id=2fbac22f"
import script from "./ExternalDataWidget.vue?vue&type=script&lang=js"
export * from "./ExternalDataWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports